import { SvgAsset, type TSvgAssetProps } from '../../components/svgAsset/SvgAsset';

const BookingRegistration = (props: TSvgAssetProps) => (
  <SvgAsset width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" fill="none" />
    <path d="m8 13 4-7 4 7" fill="none" />
    <path d="M9.1 11h5.7" fill="none" />
  </SvgAsset>
);

export default BookingRegistration;
